module.exports = __webpack_public_path__ + "media/boxshooter.ae5e20f6.mp4";